import { render, staticRenderFns } from "./firm-type.vue?vue&type=template&id=11f05865&"
import script from "./firm-type.vue?vue&type=script&lang=js&"
export * from "./firm-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports